<template>
  <div></div>
</template>

<script>
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/vue';

import { axiosClient, axiosNuxt } from '~/common/js/axios';
// import { mapState } from 'pinia'
import { isLoginedToken, coinNameToRate } from '~/common/js/utils';
import commonMixins from '~/mixins/common';
// import { useIndexStore } from "~/store/index";
// import { useTradeStore } from "~/store/trade";
// import { useAccountStore } from "~/store/account";
// import { useMarginStore } from "~/store/margin";
import { usePatchStore } from '~/common/js/patch';
import { setInviteCodeInCookie } from '~/frontend-shared/helper/invite-util';
export default {
  name: 'ClientcommonCompo',
  mixins: [commonMixins],
  data() {
    return {
      showDialogNotice: false,
      noticeData: {},
      isRenewIng: false,
      sint: null,
    };
  },
  computed: {
    locale() {
      return this.store?.locale;
    },
    // accessObj() {
    //   // TODO 3619
    //   const state = this.store;
    //   return {
    //     token: state?.token,
    //     salt: state?.salt,
    //   };
    // },
    isLogined() {
      return this.store.isLogined;
    },
    // ...mapState(useIndexStore, {
    //   locale: store => store.locale,
    //   accessObj: (state) => ({
    //     token: state.token,
    //     salt: state.salt,
    //   }),
    //   isLogined: store => store.isLogined
    // }),
  },
  async created() {
    // const commit = this.$store.commit
    if (process.client && Cookies.get('userName')) {
      this.commit('SET_USER', Cookies.get('userName'));
    }
    // 判断是否是app环境「同步执行、异步执行无法覆盖所有初始化场景」
    // const isApp = process.client && !!window.jsBridge
    // if (isApp) {
    //   initAppLoginStatus(this)
    // }
    // 前置的接口请求放在这里，页面渲染依赖这些接口的数据
    await this.initData();
  },
  mounted() {
    // 获取最新法币汇率信息，并存储到vuex
    // this.getCurrentRate()
    // 获取交易限制白名单
    this.dispatch('trade/getTradeFeeWhiteList');
    this.setInviteCodeToStorage();
    this.setInviteTypeToStorage();
    document.addEventListener('visibilitychange', () => {
      // 超过2小时离开页面，重新进入，刷新页面， 避免ws重连问题
      if (document.visibilityState === 'visible') {
        if (window.leaveTime && Date.now() - window.leaveTime >= 2 * 3600 * 1000) {
          window.location.reload();
        }
      } else {
        window.leaveTime = Date.now();
      }
    });
    // this.requestVersion()
    // this.dispatch('margin/getMarginAccountBlock')
    // this.dispatch('trade/getPrivateList')
    this.setSentryInfo();

    // 检查用户是否为agent
    setTimeout(() => {
      if (isLoginedToken()) {
        this.dispatch('account/getIsAgent');
        this.dispatch('account/getIsAffiliate');
      }
    }, 500);

    clearTimeout(this.sint);
    // 避免别的 window 已经登录
    // 如果app就不retoken
    this.$$isApp().then((isApp) => {
      if (isApp) {
        return;
      }

      this.sint = setInterval(() => {
        // 设置userName
        const userName = Cookies.get('userName');
        if (userName && userName !== 'undefined') {
          // this.indexStore.SET_USER(Cookies.get('userName'))
          this.commit('SET_USER', Cookies.get('userName'));
        }
      }, 5000);
    });
  },
  methods: {
    // async requestVersion() {
    //   const timestamp = await getVersion()
    //   const timeDiff = timestamp - Date.now()
    //   window.localStorage.setItem('timeDiff', timeDiff)
    //   window.localStorage.setItem('nowtime', timestamp)
    // },
    async initData() {
      await this.getMarketsCoinList();
    },
    async getMarketsCoinList() {
      const url = process.client ? '/gw-api/ds/market-coin' : '/ds/market-coin';
      const fetch = process.client ? axiosClient : axiosNuxt;
      const coinListRes = await fetch({
        url,
        method: 'GET',
      });
      const coinList = coinListRes?.data?.list || [];
      if (this.$isAutoJump) return;
      const fiatArr = Object.keys(coinNameToRate);
      // 调用汇率接口获取这些计价币对美元的汇率
      const rateUrl = process.client ? '/gw-api/data-awesome/coin/rate/v1/list' : '/data-awesome/coin/rate/v1/list';
      const rateRes = await fetch({
        url: rateUrl,
        method: 'post',
        data: {
          coinNameList: coinList?.map((item) => item.coinShortName).concat(fiatArr),
        },
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!rateRes?.success) {
        return false;
      }
      const rateList = rateRes?.data || [];
      if (!rateList.length) {
        return false;
      }
      const fiatList = [];
      const coinRateMap = {};
      // 因为汇率包括了计价币和法币的汇率，所以需要拆开
      rateList.forEach((item) => {
        if (item.coinId < 0) {
          fiatList.push(item);
        } else {
          coinRateMap[item.coinName] = {
            rate: item.latestCoinRate,
            isEnabled: item.latestCoinRateEnable,
            coinId: item.coinId,
            coinName: item.coinName,
          };
        }
      });
      this.commit('SET_MARKET_COIN_RATE_MAP', coinRateMap);
      this.commit('SET_EXCHANGE_RATE', fiatList || []);
    },
    // 设置sentry内容
    // 简略处理
    setSentryInfo() {
      // 2022-08-04 lisfan 将app中的username进行隐私处理
      const setUserNamePrivacy = function (name) {
        if (!name || typeof name !== 'string') return name;

        // 名称中超过4个且存在连续的4个****时，不处理
        // 名称中不超过4个且存在1个*时，不处理
        if (name.length <= 4 && name.indexOf('*') >= 0) return name;
        if (name.length > 4 && name.indexOf('****') >= 0) return name;

        return name.replace(/([^@]*)(@?.*)/, ($0, $1, $2) => {
          let privacyLength = Math.floor($1.length / 2);
          privacyLength = privacyLength > 4 ? 4 : privacyLength;

          return (
            $1.slice(0, $1.length / 2 - privacyLength / 2) +
            '*'.repeat(privacyLength) +
            $1.slice($1.length / 2 + privacyLength / 2) +
            $2
          );
        });
      };

      Sentry.setUser({
        username:
          setUserNamePrivacy(Cookies.get('userName')) ||
          window.appDeviceID ||
          window.device ||
          window.localStorage.getItem('getAnonymousID'),
      });
    },
   
    // 全局性记录user中的inviteCode到cookie中
    setInviteCodeToStorage() {
      const inviteCode = this.$route?.query?.r;
      setInviteCodeInCookie(inviteCode);
    },
    // 全局性记录user中的inviteType到cookie中
    setInviteTypeToStorage() {
      const inviteType = this.$route?.query?.inviteType;
      if (!inviteType) {
        // 如果存在，则一定会被更新为最新的过期时间，超出
        // 如果不存在，则查看inviteType是否存在
        const inviteTypeExpires = window.localStorage.getItem('inviteTypeExpires');
        if (Date.now() > inviteTypeExpires) {
          window.localStorage.removeItem('inviteType');
          window.localStorage.removeItem('inviteTypeExpires');
        }
        return;
      }

      window.sessionStorage.setItem('inviteType', inviteType);
      window.localStorage.setItem('inviteType', inviteType);
      window.localStorage.setItem('inviteTypeExpires', Date.now() + 7 * 24 * 60 * 60 * 1000);
    },
  },
  setup() {
    const { store, dispatch, commit } = usePatchStore();
    return {
      store,
      dispatch,
      commit,
    };
  },
};
</script>

<style lang="less"></style>
